@let isMdOrAbove = viewportSelectors.isMdAndUp | select;
@let author = selectors.authorFor(catalogRecord) | select;
@let series = selectors.marcDetailsSeriesStringFor(catalogRecord) | select;

<div class="flex flex-row text-wrap gap-3 md:gap-5 items-center md:items-start">
  <!-- Cover Image -->
  <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
    <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="8.75" [heightRem]="isMdOrAbove ? 10.75 : 8" [priority]="true"/>
  </a>

  <!-- Details -->
  <div class="flex flex-col gap-1 py-4 text-body-large">
    <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}" mxTruncate [mxTruncateMaxLines]="3"
       class="text-headline-small">
      {{ selectors.titleFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}
    </a>

    <p>
      by
      @if (author) {
        <a pxNamedRouterLink="CATALOG_SEARCH" [pxQueryParams]="{q: author, searchTarget: 'AUTHOR'}" class="text-title-medium">{{ author }}</a>
      } @else {
        <span class="text-title-medium">{{ DEFAULT_EMPTY_VALUE_REPLACEMENT_STRING }}</span>
      }
    </p>

    <p>{{ selectors.materialTypeDescriptionFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</p>

    <p>{{ selectors.publicationDateFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</p>

    @if (series) {
      <a pxNamedRouterLink="CATALOG_SEARCH" [pxQueryParams]="{q: series, searchTarget: 'SERIES'}" class="text-title-medium">{{ series }}</a>
    }
  </div>
</div>
